module.exports = __webpack_public_path__ + "static/logo-544e8f3c40f47da6d52936ecc1a5e048.png";